// extracted by mini-css-extract-plugin
module.exports = {"container":"Society_container__Bgf5i","sidebar":"Society_sidebar__2gE4J","main":"Society_main__4_CTx","form":"Society_form__K4Ugr"};